import React, { useState } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import AddEmployee from "./AddEmployee";
import useEmployee from "src/business-types/grocery/hooks/useEmployee";
import CommonTable from "src/business-types/grocery/components/CommonTable";
import { staff_list } from "src/business-types/grocery/components/tableHeaders";
import { UserTable } from "../settingInterface";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { notifyWarning } from "src/assets/toastService";
import PopupModules from "src/features/auth/components/PopupModules";
import { User } from "src/shared/types";

function Employee() {
  const [modalOpen, setModalOpen] = useState(false);
  const { employee, isLoadingStaff, Refetch, deleteConfirm } = useEmployee();
  const [editData, setEditData] = useState<User | null>(null);
  const [deleteId, setDeleteId] = useState<User | null>(null);

  const staffTableData: UserTable[] = employee.map((item: any, index: number) => ({
    "S.No": index + 1,
    id: item._id?.$oid || "",
    Name: item.firstName + " " + item.lastName || "",
    userName: item.userName || "",
    phoneNumber: item.phones[0]?.phone || "",
    doj: item.dateOfJoining || "",
    dol: item.modifiedOn?.$date || "",
    Email: item.emails[0].email || "",
    status: item.status || "",
    workingBranch: item.branchName || "",
    role: item.roles?.[0] || "",
  }));

  const selectEditData = (id: any) => {
    const filterData = employee.filter((i) => i._id.$oid === id)[0];
    if (filterData?.roles?.includes("Owner")) {
      notifyWarning("Owner role cannot be edited");
      return;
    }
    setEditData(filterData);
    setModalOpen(true);
  };

  const selectDelete = (id: any) => {
    const filterData = employee.filter((i) => i._id.$oid === id[0])[0];
    if (filterData?.roles?.includes("Owner")) {
      notifyWarning("Owner role cannot be deleted");
      return;
    }
    setDeleteId(filterData);
  };

  const handleDeleteConfirm = (id: any) => {
    deleteConfirm(id, () => setDeleteId(null));
  };

  return (
    <div className='w-full h-full p-3 overflow-auto bg-white rounded-2xl shadow m-1'>
      <div className='w-full flex justify-end pt-2 px-12'>
        <Button label='Add User' variant='ThemeBase' onClick={() => setModalOpen(true)} />
      </div>

      <div className='mx-1 flex justify-center'>
        {/* If you want to show the user table */}
        <CommonTable
          data={staffTableData}
          selectable={false}
          shortByTable={false}
          headCells={staff_list}
          title=''
          Action={true}
          onDeleteSelected={(data) => selectDelete(data)}
          onEditSelected={(id) => selectEditData(id)}
        />
      </div>

      <AddEmployee
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setEditData(null);
          Refetch();
        }}
        editData={editData}
      />

      <PopupModules isOpen={deleteId === null ? false : true} onClose={() => setDeleteId(null)} title='Confirm To Delete'>
        <div className='w-full text-center px-4 py-2'>
          <p className='text-sm text-gray-600 mb-4'>
            The following Employee will be <span className='font-semibold text-red-600'>DELETED</span>.<br />
            This action <span className='font-semibold'>cannot be undone.</span>
          </p>

          <div className='max-h-40 overflow-y-auto border rounded-md p-3 bg-gray-50 mb-5'>
            <div className='flex items-center text-sm border-b last:border-none py-1'>
              <span className='w-6 text-gray-500'>{1}.</span>
              {/* <span className='flex-1 text-left text-gray-700'>{deleteId?.employee_name}</span> */}
            </div>
          </div>

          <div className='flex justify-center gap-4'>
            <Button label='Cancel' variant='ThemeCancel' className='border' onClick={() => setDeleteId(null)} />
            <Button label='Delete' variant='danger' onClick={() => handleDeleteConfirm(deleteId?._id.$oid)} />
          </div>
        </div>
      </PopupModules>
      {isLoadingStaff && <LoadingScreen />}
    </div>
  );
}

export default Employee;
